import React, { useContext, useEffect } from 'react';
import './App.scss';
import SettingsModal from './Components/SettingsModal';
import AboutModal from './Components/AboutModal';
import { StateStore } from './store';
import Registration from './Components/Registeration';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import HeaderMobile from './Components/HeaderMobile';
import Home from './Components/Home';
import { timeGreater } from './Functions';
import { setAuthListener } from './Actions/AuthActions';
import Loading from './Components/Loading';

function App() {

  const { state, dispatch } = useContext(StateStore);
  const { preferences, timings, user, isAuthenticated } = state;
  const [settingsModalState, setSettingsModal] = React.useState(false);
  const [aboutModalState, setAboutModal] = React.useState(false);

  // if (!hasInitialised) return (
  //   <Registration></Registration>
  // );

  useEffect(() => {
    const toUnsubscribe = setAuthListener(dispatch, () => {
      setSettingsModal(false);
    });
    return () => toUnsubscribe.forEach(unsubscribe => unsubscribe());
  }, [dispatch]);

  const currTime = (new Date().getHours()) + ":" + (new Date().getMinutes());

  return (
    <div className={`App ${preferences?.theme === "auto" ? (timeGreater(currTime, timings?.Sunrise) && timeGreater(timings?.Sunset, currTime) ? "light" : "dark") : preferences?.theme}-theme`}>
      <HeaderMobile>
        {user ? <FontAwesomeIcon icon={faCog} className="icon" onClick={() => setSettingsModal(true)}></FontAwesomeIcon> : null}
        <div className="text">Prayer Journal</div>
      </HeaderMobile>
      {
        user ?
        // user || isAuthenticated ?
          <>
            <Home currTime={currTime} setSettingsModal={setSettingsModal} setAboutModal={setAboutModal}></Home>
            {settingsModalState ? <SettingsModal toggle={setSettingsModal} modalIsOpen={settingsModalState}></SettingsModal> : null}
            {aboutModalState ? <AboutModal theme={preferences?.theme} toggle={setAboutModal} modalIsOpen={aboutModalState}></AboutModal> : null}
          </> : isAuthenticated ? <div className="centerfull"><Loading bright={preferences?.theme === 'dark'}></Loading></div> : <Registration></Registration>
      }
    </div>
  );
}

export default App;
